        <div *ngIf="displayAddingAnchors" #anchorPanel class="add-context-dropdown" [ngClass]="layoutClass">
          <div class="add-context-dropdown-body">
            <ng-container *ngIf="mode == 'add-anchor' && reference == null">
              <div class="add-context-dropdown-select">              
                <p-select [options]="refDocs" optionLabel="docName" optionValue="docId"
                  [placeholder]="'translate.general.selectRefDoc' | translate"
                  [(ngModel)]="selectedRefDocId" (onChange)="onRefDocSelect($event)"
                  appendTo="body"
                  [disabled]="disabled"
                  panelStyleClass="ref-doc-dropdown-panel"
                  [style]="{'width': '100%'}">
                  <ng-template let-doc pTemplate="selectedItem">
                    <span [pTooltip]="doc.docName" tooltipPosition="top" style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;">{{ doc.docName }}</span>
                  </ng-template>
                  <ng-template let-doc pTemplate="item">
                    <span [pTooltip]="doc.docName" tooltipPosition="top" style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;">{{ doc.docName }}</span>
                  </ng-template>
                </p-select>
              </div>
            </ng-container>
            <div *ngIf="selectedRefDoc" class="add-context-anchor-dropdown">
              <p-select [options]="selectedRefDoc.anchors" optionValue="refDocAnchorId"
                [placeholder]="'translate.cat.selectAnchor' | translate"
                [(ngModel)]="selectDisplayValue"
                (onChange)="onAnchorSelect($event)"
                appendTo="body"
                [disabled]="disabled"
                panelStyleClass="anchor-dropdown-panel"
                [style]="{'width': '100%'}">
                <ng-template let-anchor pTemplate="selectedItem">
                  <span [pTooltip]="anchor?.embeddedObjectAnnotation.anchorPath ?? anchor?.embeddedObjectAnnotation.startingPhrase" tooltipPosition="top" style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;">{{ anchor?.embeddedObjectAnnotation.anchorPath ?? anchor?.embeddedObjectAnnotation.startingPhrase }}</span>
                </ng-template>
                <ng-template let-anchor pTemplate="item">
                  <span [pTooltip]="anchor.embeddedObjectAnnotation.anchorPath ?? anchor.embeddedObjectAnnotation.startingPhrase" tooltipPosition="top" style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;">{{ anchor.embeddedObjectAnnotation.anchorPath ?? anchor.embeddedObjectAnnotation.startingPhrase }}</span>
                </ng-template>
                
              </p-select>
            </div>
          </div>
          <div class="add-context-dropdown-footer">
            <button class="btn btn-primary btn-sm" title="{{ 'translate.add-anchors.add' | translate }}" style="color: #0978a2;" (click)="addSelectedRefDoc()" [disabled]="!(selectedRefDoc && selectedAnchor) || disabled"><i class="fas fa-plus" [class.disabled]="!(selectedRefDoc && selectedAnchor) || disabled"></i></button>
            <button class="btn btn-primary btn-sm" title="{{ 'translate.add-anchors.draw-bounding-box' | translate }}" style="color: #0978a2; margin-left: 20px;" (click)="drawAnchorBoundingBox()" [disabled]="selectedRefDoc == null || disabled"><i class="fas fa-pencil-ruler toolbar-icon" [class.disabled]="selectedRefDoc == null || disabled"></i></button>
          </div>
        </div>

        <div *ngIf="displayErrorMessage" class="displaying-error-message">

          {{ 'translate.general.addAnchor.noMatchingReference' | translate }}
        </div>

<modal-popup
  *ngIf="displayPdfForDrawingAnchors && selectedRefDoc != null"
  [flexible]="false"
  [hideHeader]="false"
  [title]="selectedRefDoc.docName"
  [isOpen]="displayPdfForDrawingAnchors && selectedRefDoc != null"
  (onClose)="closePdfForAddingBoundingBoxAnchor()"
>
  <div class="pdf-container">
    <pdf-viewer
      #docViewer
      [doc]="selectedRefDoc"
      [initialPage]="1"
      [displayDrawMode]="true"
      [displayToggleBoundingBoxes]="false"
      [displayToggleAnnotations]="false"
      [singlePage]="false"
      (onBoundingBoxDraw)="boundingBoxDraw($event)"
      (onPageChanged)="disableDrawModeOnPageChange()"
    ></pdf-viewer>
  </div>

<create-bounding-box-anchor-form *ngIf="displayFormForCreatingBoundingBoxAnchor"
(createBoundingBoxAnchor)="createBoundingBoxAnchor($event)" (onClose)="closeCreateBoundingBoxAnchorForm()"
[existingAnchors]="this.claimReference?.anchors ?? this.reference?.anchors"
[anchorToCreate]="anchorToCreate">
  
</create-bounding-box-anchor-form>
</modal-popup>
